// Default local addresses for Hardhat (chainId 31337)
const DEFAULT_LOCAL_USDC = "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238";
const DEFAULT_LOCAL_RED_PACKET = "0x2a3D0A65c677c6c31fcfE409d6dB2E3a0A2d1506";
const DEFAULT_LOCAL_TRANSFORM = "0xf2D99DDf92785AdC3E46a219CC3b7074568E9b89";
const DEFAULT_LOCAL_XXB = "0xA480f10aca35b20cd8C95056bA72B5Ac1b4f4445";
const DEFAULT_GOODS = "0x071567f3a5c8Cb33EDC50A292b914F33C0607872"

export const USDC = process.env.NEXT_PUBLIC_USDC_ADDRESS || DEFAULT_LOCAL_USDC;
export const RED_PACKET = process.env.NEXT_PUBLIC_RED_PACKET_ADDRESS || DEFAULT_LOCAL_RED_PACKET;
export const TRANSFORM = process.env.NEXT_PUBLIC_TRANSFORM_ADDRESS || DEFAULT_LOCAL_TRANSFORM;
export const XXB = process.env.NEXT_PUBLIC_XXB_ADDRESS || DEFAULT_LOCAL_XXB;
export const GOODS = process.env.NEXT_PUBLIC_GOODS_ADDRESS || DEFAULT_GOODS;